
  export const SEAT_HEIGHT_FACTOR: number = 0.885;
